import type { ReleaseStatus } from '@/integrations/faturamento/client';

/**
 * Estado do ciclo **na voz do gerador**, definido pela PD em 24/08/2026 (retorno de QA).
 *
 * Deliberadamente **diferente** dos rótulos do SFM (`ReleaseStatus.enum.ts`): o mesmo estado é
 * uma coisa para quem opera o faturamento e outra para quem recebe a fatura. "Pronta para
 * faturar" descreve a fila interna da Musa; do lado do gerador o que importa é que a medição
 * já saiu das mãos dele e aguarda o faturamento. O par estado↔rótulo é o contrato de tradução,
 * e o valor da API é o mesmo nos dois lados.
 *
 * `CREATED` não aparece de propósito: ciclo ainda não publicado não chega ao portal (RN-33).
 */
export const MEASUREMENT_STATUS_CONFIG: Record<
  ReleaseStatus,
  { label: string; variant: 'primary' | 'warning' | 'success' | 'destructive' | 'secondary' }
> = {
  AWAITING_GENERATOR: { label: 'Aguardando aprovação',   variant: 'primary' },
  CONTESTED:          { label: 'Contestada',             variant: 'secondary' },
  READY_TO_INVOICE:   { label: 'Aguardando faturamento', variant: 'primary' },
  CANCELLED:          { label: 'Cancelada',              variant: 'destructive' },
};

/**
 * Selo do ciclo vencido sem PO (EDD-582). Não é um `release_status` — o estado do ciclo segue
 * AWAITING_GENERATOR —, por isso fica fora do filtro de estados abaixo.
 */
export const AWAITING_PO_CONFIG: { label: string; variant: 'warning' } = {
  label: 'Aguardando PO',
  variant: 'warning',
};

export const MEASUREMENT_STATUS_OPTIONS = (
  Object.keys(MEASUREMENT_STATUS_CONFIG) as ReleaseStatus[]
).map(value => ({ value, label: MEASUREMENT_STATUS_CONFIG[value].label }));

export function measurementStatusLabel(status: string): string {
  return MEASUREMENT_STATUS_CONFIG[status as ReleaseStatus]?.label ?? status;
}
